var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4238 14.8994C11.2734 14.8994 11.123 14.844 11.0042 14.7252C10.7746 14.4956 10.7746 14.1156 11.0042 13.886L15.3901 9.50022L11.0042 5.11438C10.7746 4.8848 10.7746 4.5048 11.0042 4.27521C11.2338 4.04563 11.6138 4.04563 11.8434 4.27521L16.6488 9.08063C16.8784 9.31022 16.8784 9.69021 16.6488 9.9198L11.8434 14.7252C11.7246 14.844 11.5742 14.8994 11.4238 14.8994Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0947 10.0938H2.771C2.44641 10.0938 2.17725 9.82458 2.17725 9.5C2.17725 9.17542 2.44641 8.90625 2.771 8.90625H16.0947C16.4193 8.90625 16.6885 9.17542 16.6885 9.5C16.6885 9.82458 16.4193 10.0938 16.0947 10.0938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ab6a89e2c4425193544ffdb623109ab7.svg";
export { ForwardRef as ReactComponent };